<app-accordion collapsible="true">
  <app-accordion-item [heading]="accordionHeader">
    <app-radio-group
      [ngModel]="selectedBaseMap()"
      (ngModelChange)="selectedBaseMap.set($event)"
      orientation="vertical"
    >
      @for (item of layerMetaData(); track $index) {
      <app-radio-item [value]="item">{{ item.title }}</app-radio-item>
      }
    </app-radio-group>
  </app-accordion-item>
</app-accordion>

<ng-template #accordionHeader>
  <div class="flex content-center items-center gap-1"></div>
  {{ title() }}
</ng-template>
